// Stories rail - simple native embeds (like purple.md).
//
// Data comes from the `ap_story` CPT, injected as AP_DATA.stories by
// inc/enqueue.php. Each story:
//   { id, title, description, cover, videoType: 'mp4'|'youtube', video }
//   - youtube → `video` is a YouTube embed URL, shown as a native <iframe>
//     (YouTube's own poster + play button + controls; plays inline on click)
//   - mp4     → `video` is a direct file URL, shown as a native <video controls>
//
// No custom player/modal: we just render the platform embeds. Iframes are
// lazy-loaded so a homepage full of embeds doesn't tank initial load.
import { qs } from '../lib/dom.js';

function getStories() {
  const data = (typeof window !== 'undefined' && window.AP_DATA && Array.isArray(window.AP_DATA.stories))
    ? window.AP_DATA.stories
    : [];
  return data.filter((s) => s && s.video);
}

function esc(str) {
  return String(str == null ? '' : str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

// Drop autoplay so a rail of embeds doesn't all try to play at once - the
// viewer taps the platform's own play button.
function embedSrc(url) {
  return String(url).replace(/([?&])autoplay=1&?/g, '$1').replace(/[?&]+$/, '');
}

function storyHTML(s) {
  const title = esc(s.title);
  if (s.videoType === 'youtube') {
    return `<div class="ap-story"><iframe class="ap-story__embed" src="${esc(embedSrc(s.video))}" title="${title}" loading="lazy" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe></div>`;
  }
  const poster = s.cover ? ` poster="${esc(s.cover)}"` : '';
  return `<div class="ap-story"><video class="ap-story__embed" src="${esc(s.video)}"${poster} controls playsinline preload="none"></video></div>`;
}

export function initStories() {
  const root = qs('[data-component="stories"]');
  if (!root) return;
  const rail = qs('[data-role="stories-rail"]', root);
  if (!rail) return;

  const stories = getStories();
  if (!stories.length) { root.hidden = true; return; }

  rail.innerHTML = stories.map(storyHTML).join('');
}
